import store from 'config/store'
import { permacloseConversation, receiveMessageSent, setIsTyping} from 'modules/conversations/actions'
import { sendMessageRoundTripMetric } from 'modules/message/metrics/roundTrip'
import { identifyLead } from 'modules/session/actions'
import { path } from 'ramda'

import { USER_EVENTS } from './constants'
import { evaluateNewMessage } from './messages'

export const messageSent = {
  topic: 'data:sentMessage',
  event: (payload: any) => {
    store.dispatch(receiveMessageSent(payload))
  }
}

export const typingStarted = {
  topic: 'typing:started',
  event: (payload: any) => {
    window.fallbackTimeout && window.clearTimeout(window.fallbackTimeout)
    store.dispatch(setIsTyping({
      conversationId: payload.conversationId,
      userId: payload.userId,
      isTyping: true
    }))

    window.fallbackTimeout = window.setTimeout(() => {
      store.dispatch(setIsTyping({
        conversationId: payload.conversationId,
        userId: payload.userId,
        isTyping: false
      }))
    }, 5000)
  }
}

export const typingFinished = {
  topic: 'typing:finished',
  event: (payload: any) => {
    store.dispatch(setIsTyping({ conversationId: payload.conversationId, isTyping: false }))
  }
}

const sendRoundTripEventForLocalMessages = (payload: Record<string, any>) => {
  const widgetGuid = path(['body', 'data', 'attributes', 'widgetGuid'], payload)
  const isLocalMessage = !!widgetGuid

  if(isLocalMessage && !!payload.body.data) {
    sendMessageRoundTripMetric({ message: payload.body.data, timedOut: false })
  }
}

const onUserChangeEvent = async (payload: any) => {
  sendRoundTripEventForLocalMessages(payload)

  const isNewMessage = payload.body.type === 'CREATE' &&
    payload.body.object.type === 'MESSAGE'

  if (isNewMessage) {
    evaluateNewMessage(payload)
  }
}

const onUserTriggeredEvent = async (payload: any) => {
  const { type, data } = payload.body

  if (type === USER_EVENTS.EMAIL_CAPTURE) {
    store.dispatch(identifyLead({ email: data.email }))
  }
}

const onUserPermacloseEvent = async ({ conversationId }: { conversationId: number }) => {
  store.dispatch(permacloseConversation({ conversationId }))
}

export const userTriggeredEvent = {
  topic: 'event',
  event: onUserTriggeredEvent
}

export const userChangeEvent = {
  topic: 'change',
  event: onUserChangeEvent
}

export const userPermacloseEvent = {
  topic: 'conversationPermaclose',
  event: onUserPermacloseEvent
}
